import { call, put } from 'redux-saga/effects';

import * as ApplicationProviders from 'data-providers/applicationsProvider';
import { selectWhen } from 'store/helpers';
import * as StartPageActions from 'store/startPage';
import * as UserActions from 'store/user';
import * as UserSelectors from 'store/user/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageGetWorksheet = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_WORKSHEET,
  handler: function* ({ payload: worksheetId }) {
    const worksheet = yield call(ApplicationProviders.getWorksheetById, worksheetId);

    if (!worksheet) {
      CreateStage.throwError({ message: 'Worksheet not found' });
    }

    const dealerId = yield selectWhen(UserSelectors.getDealerId);

    const { dealer: worksheetDealer } = worksheet;
    const { id: worksheetDealerId } = worksheetDealer ?? {};

    if (dealerId !== worksheetDealerId) {
      yield put(UserActions.changeActiveDealer(worksheetDealerId));
    }

    yield put(StartPageActions.storeItem(worksheet));
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_WORKSHEET,
}).watcher;
